export default __webpack_public_path__ + "static/media/verve.4c9ebc50.svg";